<template>
    <div class="send-message-container">
        <loading :show="loading"></loading>
        <div @click="showModal('sendMessageModal' + business.id)" class="d-flex justify-content-between"><i class="icon-email"></i>
            <span v-if="!hideSendMessageText">Send Message</span>
        </div>
        <modal
            :name="'sendMessageModal' + business.id"
            title="Drop us a line"
            classes="whatswhat-modal send-message-modal"


            :hide-footer="true"
            size="lg"
            :adaptive="true"
            height="auto"
            :shiftY="0.3"
        >
            <div class="close-modal" @click="closeModal('sendMessageModal' + business.id)">
                <i class="icon-cross"></i>
            </div>
            <h2>Drop us a line</h2>
            <hr />
            <div class="detailedstep">

                    <input type="hidden" name="path" id='path' value=""/>
                    <div class="detailedstep__input">
                        <input type="text" class="input__text" id="nameInput" v-model="name" name="input_name" placeholder="Your name" required/>
                    </div>
                    <div class="detailedstep__input">
                        <input type="text" class="input__text" id="phoneInput" v-model="phone" name="input_phone" placeholder="Phone number" required/>
                    </div>
                    <div class="detailedstep__input">
                        <input type="email" class="input__text" id="exampleInputEmail1" v-model="email" aria-describedby="emailHelp" name="input_email" placeholder="Email address" required/>
                    </div>
                    <div class="detailedstep__input">
                        <textarea class="input__text" id="messageInput" rows="5" name="input_message" v-model="message" placeholder="Message" required></textarea>
                    </div>
                    <div class="form-group">
                        <vue-recaptcha :sitekey="recaptcha"  @verify="recaptchaVerified"></vue-recaptcha>

                    </div>

                    <button type="submit" :disabled="!recaptchaResponse" class="button button__payment mx-auto" @click="sendEmail()">Send</button>

            </div>
        </modal>
    </div>
</template>

<script>

import vue2Dropzone from "vue2-dropzone";
import { required, decimal, helpers } from "vuelidate/lib/validators";

import VueRecaptcha from 'vue-recaptcha';
import Loading  from "../components/Loading";


export default {
    props: {
        business: Object,
        recaptcha: String,
        hideSendMessageText: Boolean, // Define the hideSendMessageText prop
    },
    components: {
        Loading,
        VueRecaptcha
    },

    data() {
        return {
            loading: false,
            recaptchaResponse: null,
            recaptchaError: false,
            name: '',
            phone: '',
            email: '',
            message: ''
        };
    },

    methods: {
        closeModal(modal, reloadData = false) {
            this.$modal.hide(modal);
            this.$v.$reset();
        },

        showModal(id) {
            this.$modal.show(id);
            // this.$v.$touch();
        },
        recaptchaVerified(response) {
            this.recaptchaResponse = response;
        },
        sendEmail() {
            this.loading = true;
            let self = this;
            let messageData = {
                input_name: this.name,
                input_phone: this.phone,
                input_email: this.email,
                input_message: this.message,
                path: this.business.slug,
                'g-recaptcha-response': this.recaptchaResponse
            };
            let postUrl = '/lets-talk';
            axios.post(postUrl, messageData).then(response => {
                self.loading = false;
                if (response.data.message && response.data.message === 'Mail sent') {
                    self.$toastr.s(
                        "Your message has been sent successfully",
                        "Message sent"
                    );
                        self.closeModal('sendMessageModal' + self.business.id);

                } else {

                    }
                }).catch(function(error) {
                    self.recaptchaError = true;
            });
        }

    },
    mounted() {
        this.app_url = APP_URL;
    }
};
</script>
<style lang="scss">
.whatswhat-modal.send-message-modal {
    h2, i {
        color: #444;
    }
    .detailedstep {
        flex: 1 0 50%;
        justify-content: center;
        align-items: center!important;
        .detailedstep__input {
            width:100%;
            margin-bottom: .5em!important;
            .input__text {
                font-size: 18px;
                padding: 12px 14px 12px;
            }
        }
    }
}

</style>
